var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.examples.length)?_c('div',{staticClass:"chips"},_vm._l((_vm.examples),function(ex){return _c('button',{key:ex,staticClass:"chip",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('select', ex)}}},[_vm._v(_vm._s(ex))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }